import { Observable, observe, Scope } from 'wdc-cube'
import { WaitingScope } from '../../the-connection/tc_scopes'
import type {
    BillingEntityType,
    BillingLine,
    BillingOriginLine,
    BillingPeriodRow,
    BillingUserLine,
    PriceTierField,
    PriceTierInput
} from './bl_types'

@Observable
export class BillingHeaderScope extends Scope {}

@Observable
export class BillingChartScope extends Scope {
    @observe() caption = ''
    @observe() loaded = false
    @observe() rows = [] as BillingPeriodRow[]

    @observe() selectedPeriod?: string

    onPeriodClicked = Scope.ASYNC_ACTION_ONE<string | undefined>()
}

@Observable
export class BillingOriginScope extends Scope {
    @observe() rows = [] as BillingOriginLine[]
    @observe() loading = false
    @observe() downloading = false

    @observe() byUser = false
    @observe() byVersion = false

    @observe() context = ''

    onByUserChanged = Scope.ASYNC_ACTION_BOOLEAN
    onByVersionChanged = Scope.ASYNC_ACTION_BOOLEAN
    onDownload = Scope.ASYNC_ACTION
}

@Observable
export class BillingFilterPaneScope extends Scope {
    @observe() expanded = false

    @observe() startMonth = ''
    @observe() endMonth = ''
    @observe() groupId?: number

    @observe() month?: string

    @observe() onlyExceeded = false

    @observe() monthOptions = [] as string[]
    @observe() groupOptions = [] as { id: number; name: string }[]

    @observe() isFiltering = false

    onToggleExpanded = Scope.ASYNC_ACTION
    onStartMonthChanged = Scope.ASYNC_ACTION_STRING
    onEndMonthChanged = Scope.ASYNC_ACTION_STRING
    onMonthChanged = Scope.ASYNC_ACTION_ONE<string | undefined>()
    onOnlyExceededChanged = Scope.ASYNC_ACTION_BOOLEAN
    onGroupChanged = Scope.ASYNC_ACTION_ONE<number | undefined>()
    onApply = Scope.ASYNC_ACTION
    onClear = Scope.ASYNC_ACTION
}

@Observable
export class PriceTierEditorScope extends Scope {
    @observe() tiers = [] as PriceTierInput[]
    @observe() errors = [] as string[]

    @observe() readOnly = false
    @observe() canRemoveTier = false

    onTierChanged = Scope.ASYNC_ACTION_THREE<number, PriceTierField, string>()
    onTierAdded = Scope.ASYNC_ACTION
    onTierRemoved = Scope.ASYNC_ACTION_NUMBER
}

@Observable
export class BillingInvoiceDialogScope extends Scope {
    @observe() mode: 'INVOICE' | 'REVERSE' = 'INVOICE'
    @observe() saving = false

    @observe() entityName = ''
    @observe() competenciaLabel = ''

    @observe() valorCalculado = 0

    @observe() descontoText = ''
    @observe() observacao = ''
    @observe() motivo = ''

    @observe() errorMessage = ''

    onDescontoChanged = Scope.ASYNC_ACTION_STRING
    onObservacaoChanged = Scope.ASYNC_ACTION_STRING
    onMotivoChanged = Scope.ASYNC_ACTION_STRING
    onIsentarTotal = Scope.ASYNC_ACTION
    onConfirm = Scope.ASYNC_ACTION
    onCancel = Scope.ASYNC_ACTION
}

@Observable
export class BillingScope extends Scope {
    readonly header = new BillingHeaderScope()
    readonly filterPane = new BillingFilterPaneScope()
    readonly monthly = new BillingChartScope()
    readonly origins = new BillingOriginScope()

    @observe() invoiceDialog?: BillingInvoiceDialogScope

    @observe() waiting?: WaitingScope
    @observe() downloading = false

    @observe() totalExportado = 0
    @observe() totalExcedente = 0
    @observe() valorAFaturar = 0

    @observe() valorFaturado = 0
    @observe() linhasFaturadas = 0

    @observe() valorCortesia = 0
    @observe() linhasComCortesia = 0
    @observe() entidadesComExcedente = 0
    @observe() entidadesSemTabela = 0

    @observe() lines = [] as BillingLine[]

    @observe() selectedEntityType?: BillingEntityType
    @observe() selectedEntityId?: number
    @observe() selectedEntityName = ''

    @observe() selectedPeriod?: string

    @observe() selectedLine?: BillingLine

    @observe() detailRows = [] as BillingUserLine[]
    @observe() detailLoading = false

    onInvoiceSelected = Scope.ASYNC_ACTION
    onReverseSelected = Scope.ASYNC_ACTION
    onSelectLine = Scope.ASYNC_ACTION_THREE<BillingEntityType, number, string>()
    onDownload = Scope.ASYNC_ACTION
}

export default BillingScope
